// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hex-container[data-v-954192b2]{min-height:236px}.quote-tail[data-v-954192b2]{background:#fff;border-bottom:10px;border-right:20px solid #fff;border-top:10px;left:-20px;position:absolute;top:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
